import React from 'react';

const LoadingSpinner: React.FC<{ overlay?: boolean }> = ({ overlay }) => (
  overlay ? (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(255,255,255,0.6)', zIndex: 3000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="spinner-border" style={{ width: 48, height: 48, color: '#a2449c' }} role="status">
        <span className="visually-hidden">Carregando...</span>
      </div>
    </div>
  ) : (
    <div className="d-flex justify-content-center py-4">
      <div className="spinner-border" style={{ width: 40, height: 40, color: '#a2449c' }} role="status">
        <span className="visually-hidden">Carregando...</span>
      </div>
    </div>
  )
);

export default LoadingSpinner; 